import { createCustomField } from './create'
import { deleteCustomField } from './delete'
import { readCustomField, readCustomFields } from './read'
import { resourceObject } from './resourceObject'
import { updateCustomField } from './update'

export const customFields = {
  clientResource: resourceObject,
  create: createCustomField,
  delete: deleteCustomField,
  readSingle: readCustomField,
  readCollection: readCustomFields,
  update: updateCustomField,
}
